// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__8AN38","text":"style_text__4HX5-"};